import { render, staticRenderFns } from "./replace-label.vue?vue&type=template&id=2acd3ef1&scoped=true"
import script from "./replace-label.vue?vue&type=script&lang=tsx"
export * from "./replace-label.vue?vue&type=script&lang=tsx"
import style0 from "./replace-label.vue?vue&type=style&index=0&id=2acd3ef1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acd3ef1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2acd3ef1')) {
      api.createRecord('2acd3ef1', component.options)
    } else {
      api.reload('2acd3ef1', component.options)
    }
    module.hot.accept("./replace-label.vue?vue&type=template&id=2acd3ef1&scoped=true", function () {
      api.rerender('2acd3ef1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouse/tools/replace-label.vue"
export default component.exports